import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum GiftReceiptRequestStatus {
  UNRESOLVED = "unresolved",
  RESOLVED = "resolved",
  DELETED = "deleted",
}

export const giftReceiptRequestSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  email: z.string(),
  giftInformation: z.string(),
  status: createEnum(Object.values(GiftReceiptRequestStatus)),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const giftReceiptRequestSchema: z.ZodType<GiftReceiptRequest> =
  giftReceiptRequestSchema_;

export const GiftReceiptRequestZodArraySchema = z.array(
  giftReceiptRequestSchema_,
);

export type GiftReceiptRequest = z.infer<typeof giftReceiptRequestSchema_>;
